import React from 'react'
import Icon from 'react-icon-base'

export default props => {
  return (
    <Icon viewBox="3.021 2 18.958 19" {...props}>
      <title>{props.title || 'Fullscreen'}</title>
      <g>
        <path d="M9 9H4.021a1 1 0 1 1 0-2h4V3C8 2.448 8.447 2 9 2s1 .448 1 1v5a1 1 0 0 1-1 1zm12.979-1a1 1 0 0 0-1-1H17V3a1 1 0 1 0-2 0v5a1 1 0 0 0 1 1h4.979a1 1 0 0 0 1-1zM10 20v-5a1 1 0 0 0-1-1H4.021a1 1 0 1 0 0 2H8v4a1 1 0 1 0 2 0zm7 0v-4h3.979a1 1 0 1 0 0-2H16a1 1 0 0 0-1 1v5a1 1 0 1 0 2 0z" />
      </g>
    </Icon>
  )
}
